import { css } from "styled-components"

export const DefaultSafeAreaPadding = css`
  padding: 0 20px;
`
